export default __webpack_public_path__ + "static/use-body-text-do-07a89070a89bbaf88f74ba68d4c92b85.png";